import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const addComponentTasksToGlobalUpdate = api(async function addComponentTasksToGlobalUpdate({
    projectId,
    groupId,
    componentId,
    componentVersion,
    selection,
}) {
    return mutate(
        gql`
            mutation AddComponentTasksToGlobalUpdate(
                $projectId: String!
                $groupId: String!
                $componentId: String!
                $componentVersion: Int!
                $selection: JSONObject!
            ) {
                addComponentTasksToGlobalUpdate(
                    projectId: $projectId
                    groupId: $groupId
                    componentId: $componentId
                    componentVersion: $componentVersion
                    selection: $selection
                )
            }
        `,
        { projectId, groupId, componentId, componentVersion, selection },
        { returns: "addComponentTasksToGlobalUpdate" }
    )
})
